import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=1c7a6b2e&scoped=true&"
import script from "./Management.vue?vue&type=script&lang=js&"
export * from "./Management.vue?vue&type=script&lang=js&"
import style0 from "./Management.vue?vue&type=style&index=0&id=1c7a6b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7a6b2e",
  null
  
)

export default component.exports